let _boneBuilder = null;
let _boneApplier = null;
let _loadBoneControlForSkinnedAssets = false;
let _boneControlLoad = null;
function enableBoneControlForSkinnedAssets() {
  _loadBoneControlForSkinnedAssets = true;
}
async function _ensureBoneControlForSkinnedAsset() {
  if (!_loadBoneControlForSkinnedAssets || _boneBuilder) {
    return;
  }
  _boneControlLoad ??= import('./bone-control.js').then(({ enableBoneControl }) => enableBoneControl());
  await _boneControlLoad;
}
function _installBoneControl(builder, applier) {
  _boneBuilder = builder;
  _boneApplier = applier;
}

export { _boneApplier, _boneBuilder, _ensureBoneControlForSkinnedAsset, _installBoneControl, enableBoneControlForSkinnedAssets };
//# sourceMappingURL=bone-control-hooks.js.map
